import planiumChemicalBatchGanttView from "./planiumChemicalBatchGanttView";

// 該当ビューの顧客別バリエーションを定義

export const viewTypePlaniumChemicalBatchGanttViews = [
  planiumChemicalBatchGanttView,
];
